import type { ScreenModule } from "../../../app/screen-module";
import { ChatPage } from "../ChatPage";

export default {
	id: "end-user.chat",
	path: "/app/sessions/:sessionId",
	area: "end-user",
	label: "Guided Chat",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: ChatPage,
} satisfies ScreenModule;
